import {Box, Typography} from '@viptech/react-components'
import {ReactElement, useEffect, useRef, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import AppAddOrOptionsButton from 'src/components/AppAddOrOptionsButton'
import {useAuth} from 'src/contexts/AuthContext'
import DeleteIcon from 'src/images/DeleteIcon'
import {ContainerPaperContent} from 'src/layouts/main-layout/LayoutBase'
import {useWindowSize} from 'usehooks-ts'
import {hasCopyCameraConfigPermission, ValidateUserPermissions} from '../../common/utils/ValidatePermissions'
import {AdvancedFilters, FilterSelectedFinal} from '../../components/advancedFilters/AdvancedFilters'
import {TransparentButton} from '../../components/advancedFilters/AdvancedFiltersBase'
import AppReloadButton from '../../components/appReloadButton/AppReloadButton'
import {ConfirmationModal} from '../../components/ConfirmationModal/ConfirmationModal'
import {DropdownItem} from '../../components/dropdown/DropdownProps'
import Modal from '../../components/modal/ModalCustom'
import {SelectWithSearchComponent} from '../../components/selectWithSearchComponent/SelectWithSearchComponent'
import TopBar from '../../components/top-bar/TopBar'
import useGetCameraWarnings from '../../hooks/api/camera/useGetCameraWarnings'
import {Camera} from '../../services/api'
import {RenderIfConditionIsMet} from '../../utilities/RenderIfConditionIsMet'
import {ContainerFilters, FiltersSelectedContainer} from '../alarms/AlarmsBase'
import {translateCameraWarnings} from './CameraFunctions'
import {TopBarContainer} from './CamerasBase'
import CameraGridTable from './components/CameraGridTable'
import {CameraListCardsResponsive} from './components/CameraListCardsResponsive'
import CameraOptionsMenu from './components/CameraOptionsMenu'
import CopyConfigCameraModal from './components/CopyConfigCameraModal'
import CreateCameraStepper from './components/Stepper/CreateCameraStepper'
import CameraRegisterProvider, {useCamRegisterModalContext2} from './context/CameraRegisterContext'
import CamerasProvider, {initalCameraFilterSituation, initalCameraFilterStatus, useCameraContext} from './context/CamerasContext'

const searchFilterData = [
  {id: '1', label: 'Nome do Dispositivo'},
  {id: '2', label: 'ID do Cliente'},
  {id: '3', label: 'Nome do Cliente'},
]

type StatesOnLocalStorage = {
  itemSearch: string
  page: number
  prevPage: string
  query: string
}

function CamerasInner() {
  const {
    showOptionsButton,
    reloadCameras,
    deleteCameras,
    setCamerasSearch,
    camerasSearch,
    selectedCamerasIds,
    setSearchFilterSelected,
    loadingCameras,
    setCamerasStatus,
    toggleStatusFilter,
    toggleSituationFilter,
    searchFilterSelected,
    cameras,
    setSortByLastDetection,
  } = useCameraContext()

  const {userIsB2c} = useAuth()

  const hasCreateCameraPermission = ValidateUserPermissions('cameras:create')
  const canCopyCameraConfig = hasCopyCameraConfigPermission()

  const [menuEl, setMenuEl] = useState<null | HTMLElement>(null)
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [typeMethod, setTypeMethod] = useState<string>('')
  const [modalContent, setModalContent] = useState<string | ReactElement>('')
  const [modalTitle, setModalTitle] = useState<string>('')

  const {stepsClose} = useCamRegisterModalContext2()
  const {width} = useWindowSize()

  const menuOpen = Boolean(menuEl)

  const [showSearchFilterSelected, setshowSearchFilterSelected] = useState<DropdownItem>({
    id: '',
    label: '',
  })

  const [openCreateCameraModal, setOpenCreateCameraModal] = useState(false)

  const [cameraFilterStatus, setCameraFilterStatus] = useState<DropdownItem[]>([])
  const [cameraFilterSituation, setCameraFilterSituation] = useState<DropdownItem[]>([])
  const statusMemory = useRef<DropdownItem[]>([])
  const situationMemory = useRef<DropdownItem[]>([])

  const [showMoreFilters, setShowMoreFilters] = useState(false)
  const [chosenFilters, setChosenFilters] = useState<FilterSelectedFinal[]>([])
  const [disabledSelectFilters, setDisabledSelectFilters] = useState(false)

  const [openCopyConfigModal, setOpenCopyConfigModal] = useState(false)

  const cameraFilters = [
    {
      id: 'status',
      label: 'Status',
      itemsOnMenu: cameraFilterStatus,
    },
    {
      id: 'situation',
      label: 'Situação',
      itemsOnMenu: cameraFilterSituation,
    },
    {
      id: 'lastDetection',
      label: 'Câmeras com alertas',
    },
  ]
  useEffect(() => {
    setshowSearchFilterSelected(searchFilterData.find((it) => it.label === searchFilterSelected) ?? {id: '', label: ''})
  }, [searchFilterSelected])

  useEffect(() => {
    const filters = initalCameraFilterStatus.map((it, index) => {
      return {
        id: `${index}`,
        label: it,
      }
    })

    setCameraFilterStatus(filters)
    statusMemory.current = filters
    const situation = initalCameraFilterSituation.map((it, index) => {
      return {
        id: `${index}`,
        label: it,
      }
    })

    setCameraFilterSituation(situation)
    situationMemory.current = situation
  }, [])

  function withConfirmation(title: string, typeOption: string, content: string | ReactElement) {
    setMenuEl(null)
    setModalContent(content)
    setOpenModal(true)
    setTypeMethod(typeOption)
    setModalTitle(title)
  }

  function isConfirmation(string: string) {
    setMenuEl(null)
    if (string === 'delete') deleteCameras()
    else if (string === 'offline') setCamerasStatus(false)
    else if (string === 'online') setCamerasStatus(true)
    else if (string === 'copy-config' && canCopyCameraConfig) setOpenCopyConfigModal(true)
  }
  const {mutateAsync: getCamerasWarnings} = useGetCameraWarnings()

  async function handleSetCameraOnline(id: number) {
    const warnings = await getCamerasWarnings({cameraIds: [id]})

    if (warnings.length) {
      const reasons = translateCameraWarnings(warnings[0])

      const content = (
        <Box display='flex' direction='column' rowGap='10px'>
          <Typography variant='p'>Sua câmera foi desativada pelos seguintes motivos:</Typography>
          <ul>
            {reasons.map((reason) => (
              <li style={{paddingLeft: '-10px'}}>{reason}</li>
            ))}
          </ul>
          <Typography variant='p' weight={700}>
            Antes de prosseguir, confira se essas configurações foram corrigidas.
          </Typography>
        </Box>
      )
      return withConfirmation(`Habilitar câmera`, 'online', content)
    }
    return withConfirmation(`Habilitar câmera`, 'online', `Esta ação habilita a câmera a voltar a operar quando estiver armada.`)
  }

  function findCameraName(id: number) {
    return cameras.find((cam) => cam.id === id)?.name ?? `Câmera com id: ${id}`
  }

  async function handleSetMultipleCamerasOnline() {
    const warnings = await getCamerasWarnings({cameraIds: selectedCamerasIds})

    if (warnings.length) {
      const camerasWithWarnings = warnings.map((warning) => {
        const reasons = translateCameraWarnings(warning)
        return {
          cameraName: findCameraName(warning.cameraId),
          reasons,
        }
      })

      const content = (
        <Box>
          {camerasWithWarnings.map((camera) => {
            return (
              <Box display='flex' direction='column' rowGap='10px'>
                <Typography variant='p'>
                  A câmera <b>{camera.cameraName}</b> foi desativada pelos seguintes motivos:
                </Typography>
                <ul>
                  {camera.reasons.map((reason) => (
                    <li style={{paddingLeft: '-10px'}}>{reason}</li>
                  ))}
                </ul>
              </Box>
            )
          })}
          <Typography variant='p' weight={700}>
            Antes de prosseguir, confira se essas configurações foram corrigidas.
          </Typography>
        </Box>
      )

      return withConfirmation(`Habilitar câmeras`, 'online', content)
    }
    withConfirmation(`Habilitar câmeras`, 'online', `Esta ação habilita as câmeras a voltarem a operar quando estiverem armadas.`)
  }

  const loadNavigationState = () => {
    const savedState = localStorage.getItem('navigationState')
    return savedState ? JSON.parse(savedState) : {prevPage: 'register/devices', query: '', page: 0, itemSearch: 'Nome do Dispositivo'}
  }

  useEffect(() => {
    const savedState = localStorage.getItem('navigationState')
    if (savedState) {
      const state = JSON.parse(savedState) as StatesOnLocalStorage

      if (state.itemSearch && state.itemSearch !== searchFilterSelected && state.query) setSearchFilterSelected(state.itemSearch)
      if (state.query) setCamerasSearch(state.query)
    }
  }, [])

  const onChangeSelect = (event: DropdownItem) => {
    const value = event.label
    setshowSearchFilterSelected(event)
    setSearchFilterSelected(value)
    updateValueInLocalStorage('itemSearch', value)
  }

  useEffect(() => {
    updateValueInLocalStorage('query', camerasSearch)
  }, [camerasSearch])

  const updateValueInLocalStorage = (field: 'query' | 'page' | 'itemSearch', newValue: any) => {
    const savedState = loadNavigationState()
    savedState[field] = newValue
    localStorage.setItem('navigationState', JSON.stringify(savedState))
  }

  function handleCloseModal() {
    stepsClose()
    setOpenCreateCameraModal(false)
  }

  const handlePartialSetFilter = (newFilter: FilterSelectedFinal) => {
    if (!cameraFilterStatus.length && newFilter.id === 'status') return
    if (!cameraFilterSituation.length && newFilter.id === 'situation') return
    if (chosenFilters.some((filter) => filter.id === 'lastDetection') && newFilter.id === 'lastDetection') return
    setDisabledSelectFilters(true)
    const moreFilters = [...chosenFilters, newFilter]
    setChosenFilters(moreFilters)
    setShowMoreFilters(true)
  }

  const handleSetPartialFilters = (value: DropdownItem, index: number) => {
    setDisabledSelectFilters(false)
    const newFilter = [...chosenFilters]
    newFilter[index].selectedItem = value

    if (newFilter[index].label === 'Status') {
      setCameraFilterStatus((prev) => prev.filter((it) => it.label !== value.label))
      newFilter[index].itemsOnMenu = cameraFilterStatus

      toggleStatusFilter(value.label)
    }
    if (newFilter[index].label === 'Situação') {
      setCameraFilterSituation((prev) => prev.filter((it) => it.label !== value.label))
      newFilter[index].itemsOnMenu = cameraFilterSituation
      toggleSituationFilter(value.label)
    }
    if (newFilter[index].id === 'lastDetection') {
      setSortByLastDetection(true)
    }

    setChosenFilters(newFilter)
  }

  const deleteFilter = (index: number) => {
    const deleteItem = chosenFilters[index].selectedItem?.label
    if (!deleteItem) return

    const deleted = {
      id: chosenFilters[index].selectedItem?.id ?? '',
      label: deleteItem,
    }

    if (chosenFilters[index].label === 'Status') {
      toggleStatusFilter(deleteItem)
      setCameraFilterStatus((prev) => [...prev, deleted])
    }

    if (chosenFilters[index].label === 'Situação') {
      toggleSituationFilter(deleteItem)
      setCameraFilterSituation((prev) => [...prev, deleted])
    }

    if (chosenFilters[index].id === 'lastDetection') {
      setSortByLastDetection(undefined)
    }

    const deletedFilters = chosenFilters.filter((it) => it.selectedItem?.label !== deleteItem)
    setChosenFilters(deletedFilters)

    if (deletedFilters.length <= 0) {
      setShowMoreFilters(false)
    }
  }

  const deleteAllFilters = () => {
    const findStatusFilter = chosenFilters.filter((it) => it.label === 'Status')
    const findSituationFilter = chosenFilters.filter((it) => it.label === 'Situação')

    if (findStatusFilter) {
      findStatusFilter.forEach((it) => {
        if (!it.selectedItem) return
        toggleStatusFilter(it.selectedItem.label)
      })
    }

    if (findSituationFilter) {
      findSituationFilter.forEach((it) => {
        if (!it.selectedItem) return
        toggleSituationFilter(it.selectedItem.label)
      })
    }
    setSortByLastDetection(undefined)
    setDisabledSelectFilters(false)
    setShowMoreFilters(false)
    setChosenFilters([])

    setCameraFilterSituation(situationMemory.current)
    setCameraFilterStatus(statusMemory.current)
  }
  const navigate = useNavigate()

  const [cameratocopy, setCameraToCopy] = useState<Camera>({} as Camera)

  const choosenCameraToCopy = (cameraToCopy: Camera) => {
    if (!canCopyCameraConfig) return

    setCameraToCopy(cameraToCopy)

    withConfirmation('Copiar configuração', 'copy-config', contentCopyConfig())
  }

  const contentCopyConfig = () => {
    return (
      <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
        <p> Ao copiar uma configuração, você está copiando:</p>

        <ul>
          <li style={{paddingLeft: '-10px'}}>Áreas e linhas cadastradas</li>
          <li>Detecção de objetos e suas respectivas ações</li>
          <li>Configuração de arme e desmarme</li>
        </ul>

        <p>Tem certeza que deseja prosseguir?</p>
      </div>
    )
  }

  const handleAddNewCamera = () => {
    if (userIsB2c) navigate('/camera-config?type=new-camera')
    else setOpenCreateCameraModal(true)
  }
  return (
    <ContainerPaperContent>
      <TopBar>
        <TopBarContainer>
          <Box display='flex' columnGap='16px' width={width >= 768 ? undefined : '99%'}>
            <AppReloadButton loading={loadingCameras} onClick={() => reloadCameras()} />
            <SelectWithSearchComponent
              searchBy={searchFilterData}
              setSearchSelected={onChangeSelect}
              searchSelected={showSearchFilterSelected}
              inputValue={camerasSearch}
              inputSearch={setCamerasSearch}
              filterBy={cameraFilters}
              setSelectedFilter={handlePartialSetFilter}
              disabledSelectFilter={disabledSelectFilters}
              widthOnSelect={'310px'}
              dontSetSearchBy
            />
          </Box>

          <RenderIfConditionIsMet condition={hasCreateCameraPermission && width >= 768}>
            <AppAddOrOptionsButton
              text={`Adicionar ${userIsB2c ? 'uma Câmera' : 'um dispositivo'}`}
              showOptions={showOptionsButton}
              onClickAdd={() => handleAddNewCamera()}
              onClickOptions={(e) => setMenuEl(e.currentTarget)}
            />
          </RenderIfConditionIsMet>
        </TopBarContainer>

        <Box marginTop='15px' align='center' display='flex' justifyContent='center'>
          {showMoreFilters && (
            <ContainerFilters>
              <FiltersSelectedContainer>
                {chosenFilters.map((it, index) => {
                  return <AdvancedFilters index={index} filtersSelected={it} setFiltersSelected={handleSetPartialFilters} deleteFilter={deleteFilter} />
                })}
              </FiltersSelectedContainer>

              <TransparentButton onClick={() => deleteAllFilters()}>
                <Box display='flex' columnGap='10px' align='center'>
                  <DeleteIcon />
                  <p>Limpar Seleção</p>
                </Box>
              </TransparentButton>
            </ContainerFilters>
          )}
        </Box>
      </TopBar>

      <Modal isOpen={openCreateCameraModal} closeModal={() => handleCloseModal()} backgroundColor='white' width='60%' minHeight='700px'>
        <CreateCameraStepper closeModal={() => handleCloseModal()} reloadCameras={reloadCameras} />
      </Modal>

      {width <= 767 && userIsB2c ? (
        <CameraListCardsResponsive redirectToAddCamera={() => navigate('/camera-config?type=new-camera')} />
      ) : (
        <CameraGridTable
          setCameraOffline={() =>
            withConfirmation(
              `Desabilitar câmera`,
              'offline',
              `Esta ação desabilitará as operações desta câmera e fará com que os disparos não sejam processados.`,
            )
          }
          setCameraOnline={(e) => handleSetCameraOnline(e)}
          deleteCamera={() => withConfirmation(`Deletar câmera`, 'delete', `Esta ação removerá esta câmera do cliente e deixará de gerar eventos.`)}
          setOpenCopyConfigModal={choosenCameraToCopy}
        />
      )}

      <ConfirmationModal
        content={modalContent}
        isOpen={openModal}
        title={modalTitle}
        onClose={() => setOpenModal(false)}
        buttonsContent={[
          {
            label: 'Cancelar',
            onClick: () => setOpenModal(false),
            variant: 'outlined',
            color: '#8E8E8E',
          },
          {
            label: 'Confirmar',
            onClick: () => {
              setOpenModal(false)
              setMenuEl(null)
              isConfirmation(typeMethod)
            },
            variant: 'contained',
            color: '#009EFF',
          },
        ]}
      />
      <CameraOptionsMenu
        open={menuOpen}
        anchorEl={menuEl}
        onClose={() => setMenuEl(null)}
        onClickOffline={() =>
          withConfirmation(
            `Desabilitar câmeras`,
            'offline',
            `Esta ação desabilitará as operações destas câmeras e fará com que os disparos não sejam processados.`,
          )
        }
        onClickOnline={() => handleSetMultipleCamerasOnline()}
        onClickDelete={() => withConfirmation(`Deletar câmeras`, 'delete', `Esta ação removerá estas câmeras do cliente e deixará de gerar eventos.`)}
      />

      <Modal isOpen={openCopyConfigModal} closeModal={() => setOpenCopyConfigModal(false)} backgroundColor='white'>
        <CopyConfigCameraModal cameraToCopy={cameratocopy} closeModal={() => setOpenCopyConfigModal(false)} />
      </Modal>
    </ContainerPaperContent>
  )
}

function Devices() {
  return (
    <CamerasProvider>
      <CameraRegisterProvider>
        <CamerasInner />
      </CameraRegisterProvider>
    </CamerasProvider>
  )
}

export default Devices
